<div class="post-source-header" *ngIf="post">
  <a *ngIf="post.postedBy?.slug; else postedByAvatar"
     [routerLink]="['/' + post.postedBy.slug, 'garage']"
     (click)="stopPropagation($event)">
    <app-thumbnail classList="thumbnail-inline-block"
                   size="md"
                   [circle]="true"
                   [imgSrc]="post.postedBy.avatar | mediaObject">
    </app-thumbnail>
  </a>
  <ng-template #postedByAvatar>
    <app-thumbnail classList="thumbnail-inline-block"
                   size="md"
                   [circle]="true"
                   [imgSrc]="post.postedBy?.avatar | mediaObject">
    </app-thumbnail>
  </ng-template>

  <div class="post-source-header__meta">
    <ng-container *ngIf="showShareState; else defaultPostedByMeta">
      <span class="post-source-header__share-state">
        <a *ngIf="post.postedBy?.slug; else postedByShareName"
           [routerLink]="['/' + post.postedBy.slug, 'garage']"
           (click)="stopPropagation($event)">
          {{ post.postedBy.username }}
        </a>
        <ng-template #postedByShareName>
          <span>{{ post.postedBy?.username }}</span>
        </ng-template>
        <span class="post-source-header__share-suffix">{{ 'shared.share.root_state_suffix' | translate }}</span>
      </span>
    </ng-container>
    <ng-template #defaultPostedByMeta>
      <a *ngIf="post.postedBy?.slug; else postedByName"
         [routerLink]="['/' + post.postedBy.slug, 'garage']"
         (click)="stopPropagation($event)">
        {{ post.postedBy.username }}
      </a>
      <ng-template #postedByName>
        <span>{{ post.postedBy?.username }}</span>
      </ng-template>
    </ng-template>
    <span class="post-source-header__date">{{ post.createdAt | dateAgo }}</span>
  </div>

  <div class="post-source-header__target">
    <ng-container [ngSwitch]="post.type">
      <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_POST">
        <a *ngIf="post.project; else projectPostLabel"
           [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]"
           (click)="stopPropagation($event)">
          <i class="pi pi-caret-right pr-1"></i>
          <i class="pi pi-car pr-1"></i>
          <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
          {{ projectTargetLabel | truncateOnWord: 50: '...' }}
        </a>
        <ng-template #projectPostLabel>
          <span *ngIf="post.project">
            <i class="pi pi-caret-right pr-1"></i>
            <i class="pi pi-car pr-1"></i>
            <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
            {{ projectTargetLabel | truncateOnWord: 50: '...' }}
          </span>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_MEDIA_POST">
        <a *ngIf="post.project; else projectMediaPostLabel"
           [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]"
           (click)="stopPropagation($event)">
          <i class="pi pi-caret-right pr-1"></i>
          <i class="pi pi-image pr-1"></i>
          <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
          {{ projectTargetLabel | truncateOnWord: 50: '...' }}
        </a>
        <ng-template #projectMediaPostLabel>
          <span *ngIf="post.project">
            <i class="pi pi-caret-right pr-1"></i>
            <i class="pi pi-image pr-1"></i>
            <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
            {{ projectTargetLabel | truncateOnWord: 50: '...' }}
          </span>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="PostTypeEnum.EVENT_DISCUSSION_POST">
        <a *ngIf="post.event"
           [routerLink]="['/events', post.event.slug, EventShowTabsEnum.DISCUSSION]"
           (click)="stopPropagation($event)">
          <i class="pi pi-caret-right pr-1"></i>
          <i class="pi pi-calendar-plus pr-1"></i>
          {{ post.event.name }}
        </a>
      </ng-container>
    </ng-container>
  </div>
</div>
